import React from 'react'
import hipladeTemplate from '../../common/template'
import View from '../components/View'

function MyEventsView() {
  return <View />
}

export default hipladeTemplate(MyEventsView)
